import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';



const style = {
   width: "100%",
   maxWidth: 360,
   bgcolor: "background.paper",
   margin: "auto",
};

const Item = styled(Paper)(({ theme }) => ({
   ...theme.typography.body2,
   padding: theme.spacing(1),
   textAlign: "center",
   color: "white",
   fontFamily: "",
   paddingTop: '7.5vh',
   position: 'relative',
   minWidth: window.innerWidth < 1280 ? '350px' : '475px',
   maxWidth: '475px',
   margin: 'auto'
}));

function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`simple-tabpanel-${index}`}
         aria-labelledby={`simple-tab-${index}`}
         {...other}
      >
         {value === index && (
            <Box sx={{ p: 3, width: 'fit-content', margin: 'auto' }}>
               <Typography>{children}</Typography>
            </Box>
         )}
      </div>
   );
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.number.isRequired,
   value: PropTypes.number.isRequired,
};

function a11yProps(index) {
   return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
   };
}

export const VirtualRegistrationPricing = () => {
   const [value, setValue] = useState(0);
   const [open, setOpen] = useState(false);
   const [scrollable, setScrollable] = useState("");
   const [centered, setCentered] = useState(true);
   const [founder, setFounder] = useState(false);
   const [vip, setVip] = useState(false);
   const [platinum, setPlatinum] = useState(false);
   const [formNumber, setFormNumber] = useState(null);
   const [showForm, setShowForm] = useState("none");
   const [showLoader, setShowLoader] = useState("block");

   const handleChange = (event, newValue) => {
      setValue(newValue);
   };

   const handleClickOpen = () => {
      setOpen(true);
      setTimeout(() => {
         setShowLoader("none");
         setShowForm("block")
      }, 3000)
   };

   const handleClose = () => {
      setOpen(false);
   };

   useEffect(() => {
      if (window.innerWidth < 768) {
         setCentered(false);
         setScrollable("scrollable");
      } else {
         setCentered(true);
         setScrollable("");
      }
   }, []);

   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/tickets/tickets.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
   });

   return (
      <Box sx={{ width: "100%", color: "white !important" }}>
         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
               value={value}
               onChange={handleChange}
               centered={centered}
               variant={scrollable}
               aria-label="basic tabs example"
               scrollButtons="auto"
               sx={{ display: 'flex' }}

            >
               <Tab
                  className={value === 0 ? "custom-tab-active" : "custom-tab"}
                  sx={{ color: value === 0 && "#40B1E5 !important", fontWeight: "900", fontSize: window.innerWidth < 1100 ? ".9rem !important" : '1.5rem !important', flex: 1 }}
                  icon={value === 0 ? <img alt='Polygon' src={"./assets/media/Polygon 71.png"} /> : <img alt='Polygon' src={"./assets/media/Polygon 71 (1).png"} />}
                  iconPosition={"start"}
                  label={<div>Startups </div>}
                  {...a11yProps(0)}
               >Hello</Tab>
               <Tab
                  className={value === 1 ? "custom-tab-active" : "custom-tab"}
                  iconPosition={"start"}
                  icon={value === 1 ? <img alt='Polygon' src={"./assets/media/Polygon 72.png"} /> : <img alt='Polygon' src={"./assets/media/Polygon 72 (1).png"} />}
                  sx={{ color: value === 1 && "#34C48B !important", fontWeight: "900", fontSize: window.innerWidth < 1100 ? ".9rem !important" : '1.5rem !important', flex: 1 }}
                  label={<div> Investors </div>}
                  {...a11yProps(1)}
               />
               <Tab
                  className={value === 2 ? "custom-tab-active" : "custom-tab"}
                  iconPosition={"start"}
                  icon={value === 2 ? <img alt='Polygon' src={"./assets/media/Polygon 73.png"} /> : <img alt='Polygon' src={"./assets/media/Polygon 73 (1).png"} />}
                  sx={{ color: value === 2 && "#7956C7 !important", fontWeight: "900", fontSize: window.innerWidth < 1100 ? ".9rem !important" : '1.5rem !important', flex: 1 }}
                  label={<div> General Attendees </div>}
                  {...a11yProps(2)}
               />
            </Tabs>
         </Box>
         <TabPanel value={value} index={0}>
            <Stack
               className="registration-pricing-mobile"
               style={{ display: "none" }}
               spacing={3}
            >
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     sx={{
                        ...style,
                        backgroundColor: '#40B1E5',
                        textAlign: "center",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        founder === false ? setFounder(true) : setFounder(false);
                     }}
                  >
                     <h2 style={{ padding: '2.5%' }}>FOUNDER</h2>
                     {/* <h4>Now only $597</h4> */}
                     <h4>
                        $797
                     </h4>

                     <div>
                        More Info
                        {founder === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {founder === true && (
                        <div>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="One Founder Pass" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to all VC Panels" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Dedicated Networking Breaks" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Food and Drink Available for purchase" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Discounted Hotel Rates (while they last)" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Email Support" />
                           </ListItem>
                           {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                           <Button onClick={e => { setFormNumber(11); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </div>
                     )}
                  </List>
               </div>

               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List

                     sx={{
                        ...style,
                        backgroundColor: '#228EBF',
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        vip === false ? setVip(true) : setVip(false);
                     }}
                  >
                     <h2 >FOUNDER GOLD</h2>
                     {/* <h4>Now only $697</h4> */}
                     <h4>
                        $897
                     </h4>

                     <div>
                        More Info
                        {vip === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {vip === true && (
                        <div>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="One Founder Pass" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks

"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Discounted Hotel Rates (while they last)" />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email Support
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Opening Cocktail Reception</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Access to Matchmaking App</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Digital Copy of Conference Guide</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Snacks and Drinks</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Continental Breakfast</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Lunch</b></ListItemText>
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Phone Support</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(12); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </div>
                     )}
                  </List>
               </div>

               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List

                     sx={{
                        ...style,
                        backgroundColor: "#126A92",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        platinum === false ? setPlatinum(true) : setPlatinum(false);
                     }}
                  >
                     <h2>FOUNDER PLATINUM</h2>
                     {/* <h4>Now only $1497</h4> */}
                     <h4>
                        $1697
                     </h4>

                     <div>
                        More Info
                        {platinum === false ? (
                           <ArrowDropDownIcon />
                        ) : (
                           <ArrowDropUpIcon />
                        )}
                     </div>
                     {platinum === true && (
                        <div>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>Three</b> Founder Passes</ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to Startup Innovator Presentations
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email support
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Opening Cocktail Reception
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Matchmaking App" />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Digital Copy of Conference Guide
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Snacks and Drinks
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Continental Breakfast
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Lunch
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Phone Support" />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ VIP Registration Desk</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ VIP Seating | Main Stage</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Discount for Additional Passes</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(13); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </div>
                     )}
                  </List>
               </div>
            </Stack>
            <Grid
               className="registration-pricing-web"
               container
               spacing={3}
               sx={{ pt: 2, pr: 6, pl: 6, pb: 6 }}
            >
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#40B1E5',
                     }}
                  >
                     <h2>FOUNDER</h2>
                     <br />
                     {/* <h4>Now only $597</h4>
              <br/> */}
                     <h4>
                        $797
                     </h4>
                     <br />
                     <List
                        sx={{
                           ...style,
                           backgroundColor: '#40B1E5',
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <Divider sx={{ borderBottomWidth: 2 }} />
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="One Founder Pass
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary=" Access to all VC Panels


"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Startup Innovator Presentations



"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Email Support" />
                        </ListItem>
                        {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                        <br />
                        <Button
                           onClick={e => { setFormNumber(11); handleClickOpen() }}
                           variant="contained"
                           sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black' }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#228EBF'
                     }}
                  >
                     <h2>FOUNDER GOLD</h2>
                     {/* <br/>
              <h4>Now only $697</h4> */}
                     <br />
                     <h4>
                        $897
                     </h4>
                     <br />

                     <List
                        
                        sx={{
                           ...style,
                           backgroundColor: '#228EBF',
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <Divider light sx={{ borderBottomWidth: 2 }} />
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="One Founder Pass" />
                        </ListItem>



                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Discounted Hotel Rates (while they last)" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center", fontWeight: '900' }}>
                           <ListItemText
                           ><b>+ Opening Cocktail Reception</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ Access to Matchmaking App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Digital Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Snacks and Drinks</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Continental Breakfast</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Lunch</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ Phone Support</b></ListItemText>
                        </ListItem>
                        <br />
                        <Button onClick={e => { setFormNumber(12); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>


               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: "#126A92",
                     }}
                  >

                     <h2>FOUNDER PLATINUM</h2>

                     <br />
                     <h4>
                        $1697
                     </h4>
                     <br />
                     <List
                       
                        sx={{
                           ...style,
                           backgroundColor: "#126A92",
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <Divider sx={{ borderBottomWidth: 2 }} />
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText>
                              <b> Three</b> Founder Passes
                           </ListItemText>
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Discounted Hotel Rates (while they last)" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Opening Cocktail Reception
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Matchmaking App
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Digital Copy of Conference Guide
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Snacks and Drinks
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Continental Breakfast" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Lunch
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Phone Support" />
                        </ListItem>






                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ VIP Registration Desk</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ VIP Seating | Main Stage</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Discount for Additional Passes</b></ListItemText>
                        </ListItem>
                        <br />
                        <Button onClick={e => { setFormNumber(13); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
            </Grid>
            <br />

         </TabPanel>
         <TabPanel value={value} index={1}>
            <Stack
               className="registration-pricing-mobile"
               style={{ display: "none" }}
               spacing={3}
            >
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     
                     sx={{
                        ...style,
                        backgroundColor: '#34C48B',
                        textAlign: "center",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        founder === false ? setFounder(true) : setFounder(false);
                     }}
                  >
                     <h2>INVESTOR</h2>
                     {/* <h4>Now only $697</h4> */}
                     <h4>
                        $897
                     </h4>

                     <div>
                        More Info
                        {founder === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {founder === true && (
                        <>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary=" One Investor Pass
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary=" Access to all VC Panels


"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to Startup Innovator Presentations
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Email Support" />
                           </ListItem>
                           {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                           <Button onClick={e => { setFormNumber(14); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </>
                     )}
                  </List>
               </div>
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     
                     sx={{
                        ...style,
                        backgroundColor: '#189B67',
                        textAlign: "center",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        vip === false ? setVip(true) : setVip(false);
                     }}
                  >
                     <h2>INVESTOR GOLD</h2>
                     {/* <h4>Now only $797</h4> */}
                     <h4>
                        $997
                     </h4>

                     <div>
                        More Info
                        {vip === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {vip === true && (
                        <>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="One Investor Pass
"
                              />
                           </ListItem>


                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks

"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email Support
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Opening Cocktail Reception</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Access to Matchmaking App</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Digital Copy of Conference Guide</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Snacks and Drinks</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Continental Breakfast</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Lunch</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Phone Support</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(15); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </>
                     )}
                  </List>
               </div>
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     
                     sx={{
                        ...style,
                        backgroundColor: '#007748',
                        width: '300px',
                        textAlign: "center",
                        borderRadius: "5px",
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        platinum === false ? setPlatinum(true) : setPlatinum(false);
                     }}
                  >
                     <h2>INVESTOR PLATINUM</h2>
                     {/* <h4>Now only $1597</h4> */}
                     <h4>
                        $1797
                     </h4>

                     <div>
                        More Info
                        {platinum === false ? (
                           <ArrowDropDownIcon />
                        ) : (
                           <ArrowDropUpIcon />
                        )}
                     </div>
                     {platinum === true && (
                        <>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText>
                                 <b>Three</b> Investor Passes
                              </ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>


                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks

"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)

"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email Support


"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Opening Cocktail Reception



"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to Matchmaking App

"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Digital Copy of Conference Guide
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Snacks and Drinks
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Continental Breakfast
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Lunch
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Phone Support" />
                           </ListItem>



                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ VIP Registration Desk</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ VIP Seating | Main Stage</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ Discount for Additional Passes</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(16); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </>
                     )}
                  </List>
               </div>
            </Stack>
            <Grid
               className="registration-pricing-web"
               container
               spacing={3}
               sx={{ pt: 2, pr: 6, pl: 6, pb: 6 }}
            >
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#34C48B',
                     }}
                  >
                     <h2>INVESTOR</h2>
                     {/* <br/>
              <h4>Now only $697</h4> */}
                     <br />
                     <h4>
                        $897
                     </h4>

                     <br />
                     <Divider sx={{ borderBottomWidth: 2 }} />
                     <List
                        
                        sx={{
                           ...style,
                           backgroundColor: '#34C48B',
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >


                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="One Investor Pass" />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary=" Access to all VC Panels


"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Startup Innovator Presentations
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Email Support" />
                        </ListItem>
                        {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                        <br />
                        <Button onClick={e => { setFormNumber(14); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '1.35vh 0vh' }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#189B67'
                     }}
                  >
                     <h2>INVESTOR GOLD</h2>

                     <br />
                     <h4>
                        $997
                     </h4>
                     <br />
                     <Divider light sx={{ borderBottomWidth: 2 }} />
                     <List
                        
                        sx={{
                           ...style,
                           backgroundColor: '#189B67'
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >


                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="One Investor Pass

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Opening Cocktail Reception</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Access to Matchmaking App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Digital Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Snacks and Drinks</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Continental Breakfast</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Lunch</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Phone Support</b></ListItemText>
                        </ListItem>
                        <Button onClick={e => { setFormNumber(15); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important',  margin: '7.5% 0%', color: 'black', border: '1px solid black', }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#007748'
                     }}
                  >
                     <h2>INVESTOR PLATINUM</h2>
 
                     <br />
                     <h4>
                        $1797
                     </h4>
                     <br />
                     <Divider light sx={{ borderBottomWidth: 2 }} />
                     <List
                       
                        sx={{
                           ...style,
                           backgroundColor: '#007748'
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText>
                              <b>Three</b> Investor Passes
                           </ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support


"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary=" Opening Cocktail Reception



"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Matchmaking App

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Digital Copy of Conference Guide
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Snacks and Drinks
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Continental Breakfast
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Lunch
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Phone Support" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ VIP Registration Desk</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ VIP Seating | Main Stage</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ Discount for Additional Passes</b></ListItemText>
                        </ListItem>
                        <Button onClick={e => { setFormNumber(16); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important',  margin: '7.5% 0%', color: 'black', border: '1px solid black', }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
            </Grid>

         </TabPanel>
         <TabPanel value={value} index={2}>
            <Stack
               className="registration-pricing-mobile"
               style={{ display: "none" }}
               spacing={3}
            >
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                    
                     sx={{
                        ...style,
                        backgroundColor: '#7956C7',
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        founder === false ? setFounder(true) : setFounder(false);
                     }}
                  >
                     <h2>PROFESSIONAL</h2>
                     {/* <h4>Now only $797</h4> */}
                     <h4>
                        $997
                     </h4>

                     <div>
                        More Info
                        {founder === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {founder === true && (
                        <>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="One Professional Pass
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary=" Access to all VC Panels


"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to Startup Innovator Presentations
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Discounted Hotel Rates (while they last)" />
                           </ListItem>{" "}

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Email Support" />
                           </ListItem>{" "}
                           {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                           <ListItem>
                              <ListItemText style={{ justifyContent: 'center', display: 'flex' }}> <Button onClick={e => { setFormNumber(17); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: 'auto' }}>
                                 Register Now
                              </Button></ListItemText></ListItem>
                        </>
                     )}
                  </List>
               </div>{" "}
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     
                     sx={{
                        ...style,
                        backgroundColor:
                           "#643DB8",
                        textAlign: "center",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        vip === false ? setVip(true) : setVip(false);
                     }}
                  >
                     <h2>PROFESSIONAL GOLD</h2>
                     {/* <h4>Now only $897</h4> */}
                     <h4>
                        $1097
                     </h4>

                     <div>
                        More Info
                        {vip === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                     </div>
                     {vip === true && (
                        <>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="One Professional Pass
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks

"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email Support
"
                              />
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Opening Cocktail Reception</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Access to Matchmaking App</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Digital Copy of Conference Guide</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Snacks and Drinks</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Continental Breakfast</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Lunch</b></ListItemText>
                           </ListItem>

                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Phone Support</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(18); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </>
                     )}
                  </List>
               </div>{" "}
               <div
                  style={{
                     justifyContent: "center",
                     display: "flex",
                     textAlign: "center",
                  }}
               >
                  <List
                     
                     sx={{
                        ...style,
                        backgroundColor:
                           "#491F9A",
                        textAlign: "center",
                        borderRadius: "5px",
                        width: '300px'
                     }}
                     component="nav"
                     aria-label="mailbox folders"
                     onClick={() => {
                        platinum === false ? setPlatinum(true) : setPlatinum(false);
                     }}
                  >
                     <h2>PROFESSIONAL PLATINUM</h2>
                     {/* <h4>Now only $1697</h4> */}
                     <h4>
                        $1897
                     </h4>

                     <div>
                        More Info
                        {platinum === false ? (
                           <ArrowDropDownIcon />
                        ) : (
                           <ArrowDropUpIcon />
                        )}
                     </div>
                     {platinum === true && (
                        <>
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>Three</b> Professional Passes</ListItemText>

                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to all VC Panels
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Access to Startup Innovator Presentations" />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Dedicated Networking Breaks

"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Discounted Hotel Rates (while they last)
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Email Support

"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Opening Cocktail Reception

"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Access to Matchmaking App
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Digital Copy of Conference Guide
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Snacks and Drinks
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Continental Breakfast
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                                 primary="Lunch
"
                              />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText primary="Phone Support" />
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ VIP Registration Desk</b></ListItemText>
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText><b>+ VIP Seating | Main Stage</b></ListItemText>
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                           </ListItem>
                           <Divider light sx={{ borderBottomWidth: 2 }} />
                           <ListItem sx={{ textAlign: "center" }}>
                              <ListItemText
                              ><b>+ Discount for Additional Passes</b></ListItemText>
                           </ListItem>
                           <Button onClick={e => { setFormNumber(19); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                              Register Now
                           </Button>
                        </>
                     )}
                  </List>
               </div>
            </Stack>
            <Grid
               className="registration-pricing-web"
               container
               spacing={3}
               sx={{ pt: 2, pr: 6, pl: 6, pb: 6 }}
            >
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor: '#7956C7',
                     }}
                  >
                     <h2>PROFESSIONAL</h2>

                     <br />
                     <h4>
                        $997
                     </h4>
                     <br />
                     <Divider light sx={{ borderBottomWidth: 2 }} />
                     <List
                        sx={{
                           ...style,
                           backgroundColor: '#7956C7',
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="One Professional Pass
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary=" Access to all VC Panels


"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Startup Innovator Presentations
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support
"
                           />
                        </ListItem>
                        {/* <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText><b>ADD ONS</b></ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Opening Cocktail Reception</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Access to Matchmaking App</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Digital Copy of Event Guide</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>Snacks and Drinks Available for purchase</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$50 Continental Breakfast</ListItemText>
                  </ListItem>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemText>$100 Lunch</ListItemText>
                  </ListItem> */}
                        <Button onClick={e => { setFormNumber(17); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor:
                           "#643DB8",
                     }}
                  >
                     <h2>PROFESSIONAL GOLD</h2>
                     {/* <br/>
              <h4>Now only $897</h4> */}
                     <br />
                     <h4>
                        $1097
                     </h4>
                     <br />
                     <Divider light sx={{ borderBottomWidth: 2 }} />
                     <List
                        
                        sx={{
                           ...style,
                           backgroundColor:
                              "#643DB8",
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="One Professional Pass
"
                           />
                        </ListItem>


                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Opening Cocktail Reception</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Access to Matchmaking App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Digital Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ Snacks and Drinks</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Continental Breakfast</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ Lunch</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Phone Support</b></ListItemText>
                        </ListItem>
                        <Button onClick={e => { setFormNumber(18); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
               <Grid item xs={4}>
                  <Item
                     sx={{
                        backgroundColor:
                           "#491F9A",
                     }}
                  >

                     <h2>PROFESSIONAL PLATINUM</h2>

                     <br />
                     <h4>
                        $1897
                     </h4>
                     <br />
                     <Divider light sx={{ borderBottomWidth: 2 }} />
                     <List
                        
                        sx={{
                           ...style,
                           backgroundColor:
                              "#491F9A",
                        }}
                        component="nav"
                        aria-label="mailbox folders"
                     >
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>Three</b> Professional Passes</ListItemText>

                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to all VC Panels
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Access to Startup Innovator Presentations" />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Dedicated Networking Breaks

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Discounted Hotel Rates (while they last)
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Email Support

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Opening Cocktail Reception

"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Access to Matchmaking App
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Digital Copy of Conference Guide
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Snacks and Drinks
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Continental Breakfast
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                              primary="Lunch
"
                           />
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText primary="Phone Support" />
                        </ListItem>
                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Early Access to 1 on 1 Meeting App</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ VIP Registration Desk</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText><b>+ VIP Seating | Main Stage</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Hard Copy of Conference Guide</b></ListItemText>
                        </ListItem>

                        <ListItem sx={{ textAlign: "center" }}>
                           <ListItemText
                           ><b>+ Discount for Additional Passes</b></ListItemText>
                        </ListItem>
                        <Button onClick={e => { setFormNumber(19); handleClickOpen() }} variant="contained" sx={{ borderRadius: '15px', backgroundColor: 'white !important', color: 'black', border: '1px solid black', margin: '7.5% 0%' }}>
                           Register Now
                        </Button>
                     </List>
                  </Item>
               </Grid>
            </Grid>

         </TabPanel>
         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={"lg"}
         >
            <DialogContent sx={{ minHeight: '65vh !important', maxHeight: '85vh !important' }}>
               <div style={{ display: showLoader, justifyContent: 'center', height: showLoader && '65vh', alignItems: 'center',  }}><div id="loader" style={{ margin: '25% auto' }}><div></div><div></div></div></div>
               <div
                  id="biza-prc-div"
                  className="bizzabo-tickets-widget"
                  style={{ display: showForm }}
                  data-event-id="401218"
                  data-params={`isInMinisite=true&widgetId=1694${formNumber}`}
               ></div>
               <a
                  className="bizzabo-link-class"
                  style={{
                     textAlign: "right",
                     paddingRight: "17px",
                     textDecoration: "none",
                     width: "100%",
                     display: "inline-block",
                     marginTop: "5px",
                     boxSizing: "border-box",
                  }}
                  href="https://www.bizzabo.com?utm_source=tickets_widget&utm_medium=powered_by&utm_campaign=tickets_widget"
                  target="_blank"
                  rel="noreferrer"
               >
                  Powered by Bizzabo
               </a>
            </DialogContent>
         </Dialog>
      </Box>
   );
};
